// extracted by mini-css-extract-plugin
export default {"defectsContainer":"styles_defectsContainer__5R9vv"};